import { Link } from "react-router-dom";
import { HeartOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function GivingCancel() {
  usePageMeta("Gift Canceled");
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="max-w-lg w-full rounded-2xl bg-white border border-border p-10 text-center shadow-sm" data-testid="giving-cancel">
        <HeartOff className="mx-auto h-12 w-12 text-navy/40" />
        <h1 className="mt-5 font-display text-3xl text-navy font-semibold">Your gift was canceled</h1>
        <p className="mt-3 text-muted-foreground">
          No charge was made. Whenever you're ready, we'd be grateful for your support of this work.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Button asChild className="rounded-full bg-emerald hover:bg-emerald-dark text-white px-8"><Link to="/fund">Try again</Link></Button>
          <Button asChild variant="outline" className="rounded-full border-gold text-navy hover:bg-gold/10 px-8"><Link to="/">Return home</Link></Button>
        </div>
      </div>
    </div>
  );
}
